import type { Palettes, ThemeColors } from 'types/theme';
// import { green } from '@mui/material/colors';

// set MUI theme palette (button, checkbox & other control colors)
const palette: keyof Palettes = 'default'; // options defined in LayoutStyles.tsx

// Page & navbar colors, applied on top of the palette above. To match a companion static site
// (static-site-kit), copy the values of --background-*, --foreground-* and --accent-* from its
// app/globals.css. `paper` (form card background) has no static site equivalent: pick a color
// that stands out slightly from `background`.
const colors: Record<'light' | 'dark', ThemeColors> = {
  light: { background: '#faf0e6', foreground: '#1a1612', accent: '#d97706', paper: '#ffffff' },
  dark: { background: '#1c1714', foreground: '#ede8e3', accent: '#fbbf24', paper: '#2d2825' },
};

const config = {
  palette,
  colors,
};

export default config;
